import { render, staticRenderFns } from "./BestBuysNowStatsTable.vue?vue&type=template&id=e6867fe4"
import script from "./BestBuysNowStatsTable.vue?vue&type=script&lang=js"
export * from "./BestBuysNowStatsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports